import { Store } from 'pullstate';
import { PuzzleStoreBase, PuzzleStoreBaseDefaults } from '../../../utils/types';

export type MegarubigramStoreType = PuzzleStoreBase & {
  // This is whichever one has just been manipulated, to control
  // raising its z-index above the others for animation purposes.
  activeGrid: number;
  activeSubgrid: number;
  // This is how rotated the entire puzzle is, rather than any individual grid.
  degreesRotated: number;
  grids: Array<{
    isInFlippingAnimation: boolean; // used to hide letter rotation during flip
    flippedHorizontally: boolean;
    flippedVertically: boolean;
    // This is how rotated a 6x6 quadrant is
    degreesRotated: number;
    subgrids: Array<{
      solution: string[][]; // the correct combination for this subgrid;
      isInFlippingAnimation: boolean; // used to hide letter rotation during flip
      // This is what gets updated as the player flips and rotates the grid
      content: string[][];
      // This doesn't get updated ever; it's used to populate the visualization of the grids.
      // If we updated the data populating the grid AND flipped the grid visually,
      // then from the player's perspective it would result in each flip or rotation
      // happening twice.
      displayContent: string[][];
      flippedHorizontally: boolean;
      flippedVertically: boolean;
      // This is how rotated a 3x3 subquadrant is
      degreesRotated: number;
    }>;
  }>;
  solvedGrids: Array<{
    subgrids: Array<{
      content: string[][];
    }>,
  }>,
};

const getEmptySubGrids = () => {
  return Array.from({ length: 4 }, () => ({
    content: [],
    displayContent: [],
    solution: [],
    flippedHorizontally: false,
    flippedVertically: false,
    degreesRotated: 0,
    isInFlippingAnimation: false,
  }));
};

const getEmptyGrids = () => {
  return Array.from ({ length: 4 }, () => ({
    flippedHorizontally: false,
    flippedVertically: false,
    degreesRotated: 0,
    isInFlippingAnimation: false,
    subgrids: getEmptySubGrids(),
  }));
};

export const MegarubigramStore = new Store<MegarubigramStoreType>({
  ...PuzzleStoreBaseDefaults,
  activeGrid: 0,
  activeSubgrid: 0,
  degreesRotated: 0,
  grids: getEmptyGrids(),
  solvedGrids: getEmptyGrids(),
});